import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
	name: 'deHTMLLize',
})
export class DeHTMLLizePipe implements PipeTransform {
	transform(value: string): string {
		const textarea = document.createElement('textarea');
		textarea.innerHTML = value;
		value = textarea.value;

		let replacedText = value.replaceAll(String.raw`\n`, '\n');
		replacedText = replacedText.replaceAll('\n', '\n');
		return replacedText.replaceAll(/(<([^>]+)>)/gi, '');
	}
}
